/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateFileMetadataInput = {
  description: string,
  errors?: ErrorConfigInput | null,
  fileName: string,
  fileSize?: number | null,
  headers?: Array< string > | null,
  orgId: string,
  recordCount?: number | null,
  s3Key?: string | null,
  templateId: string,
  uploadBy?: string | null,
  uploadStatus?: UploadStatus | null,
};

export type ErrorConfigInput = {
  count?: number | null,
  errorDetails?: Array< string > | null,
};

export enum UploadStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  PROCESSING = "PROCESSING",
  UPLOADED = "UPLOADED",
  VALIDATION_FAILED = "VALIDATION_FAILED",
  VALIDATION_SUCCESS = "VALIDATION_SUCCESS",
}


export type FileMetadata = {
  __typename: "FileMetadata",
  description?: string | null,
  errors?: ErrorConfig | null,
  exportStatus?: ExportStatus | null,
  fileId: string,
  fileName: string,
  fileSize?: number | null,
  headers?: Array< string > | null,
  lastModifiedAt?: string | null,
  lastModifiedBy?: string | null,
  operatorsProcessed?: Array< string > | null,
  orgId: string,
  recordCount?: number | null,
  rowsProcessedList?: Array< string > | null,
  s3Key?: string | null,
  s3OutputKeys?: Array< string > | null,
  templateId: string,
  uploadBy?: string | null,
  uploadStatus?: UploadStatus | null,
  uploadedAt?: string | null,
  validationResults?: string | null,
};

export type ErrorConfig = {
  __typename: "ErrorConfig",
  count?: number | null,
  errorDetails?: Array< string > | null,
};

export enum ExportStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
}


export type CreateOrganization = {
  createdAt: string,
  createdBy: string,
  landingBucketConfig?: LandingBucketInputConfig | null,
  numberOfFiles?: number | null,
  orgId: string,
  orgName: string,
  orgType: OrgType,
  status: OrgStatus,
  targetColumnMapping?: string | null,
  targetColumns?: Array< TargetColumnsInputConfig > | null,
};

export type LandingBucketInputConfig = {
  bucketName: string,
  bucketPrefix: string,
  bucketRegion: string,
};

export enum OrgType {
  CLUB = "CLUB",
  LEAGUE = "LEAGUE",
}


export enum OrgStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}


export type TargetColumnsInputConfig = {
  desc: string,
  key: string,
  tagName: string,
};

export type Organization = {
  __typename: "Organization",
  createdAt: string,
  createdBy: string,
  fileTemplateConfig?:  Array<FileTemplateConfig > | null,
  landingBucketConfig?: LandingBucketConfig | null,
  lastModifiedAt: string,
  lastModifiedBy: string,
  numberOfFiles?: number | null,
  orgId: string,
  orgName: string,
  orgType: OrgType,
  status: OrgStatus,
  targetColumnMapping?: string | null,
  targetColumns?:  Array<TargetColumnsConfig > | null,
};

export type FileTemplateConfig = {
  __typename: "FileTemplateConfig",
  description: string,
  displayName: string,
  headers?: string | null,
  templateId?: string | null,
};

export type LandingBucketConfig = {
  __typename: "LandingBucketConfig",
  bucketName: string,
  bucketPrefix: string,
  bucketRegion: string,
};

export type TargetColumnsConfig = {
  __typename: "TargetColumnsConfig",
  desc: string,
  key: string,
  tagName: string,
};

export type CreateUserInput = {
  email: string,
  firstName: string,
  lastName: string,
  oktaUserId?: string | null,
  orgId: string,
  role: string,
};

export type UserResponse = {
  __typename: "UserResponse",
  message?: string | null,
  success?: boolean | null,
};

export type HashAndEncryptRequest = {
  fileId: string,
  lastModifiedBy: string,
  orgId: string,
  s3Key: string,
  uploadStatus: UploadStatus,
};

export type ProcessResponse = {
  __typename: "ProcessResponse",
  message?: string | null,
  operatorsProcessed?: Array< string > | null,
  orgId?: string | null,
  rowsProcessed?: Array< number > | null,
  s3OutputKeys?: Array< string > | null,
  statusCode?: number | null,
  success?: boolean | null,
};

export type PublishRequest = {
  lastModifiedBy: string,
  orgId: string,
  s3Key: string,
};

export type PublishResponse = {
  __typename: "PublishResponse",
  filesRemoved?: boolean | null,
  message?: string | null,
  orgId?: string | null,
  statusCode?: number | null,
  success: boolean,
};

export type UpdateFileMetadataInput = {
  description?: string | null,
  errors?: ErrorConfigInput | null,
  exportStatus?: ExportStatus | null,
  fileId: string,
  fileName?: string | null,
  fileSize?: number | null,
  headers?: Array< string > | null,
  lastModifiedBy?: string | null,
  operatorsProcessed?: Array< string > | null,
  orgId: string,
  recordCount?: number | null,
  rowsProcessedList?: Array< string > | null,
  s3Key?: string | null,
  s3OutputKeys?: Array< string > | null,
  uploadStatus?: UploadStatus | null,
};

export type UpdateOrganizationInput = {
  fileTemplateConfig?: Array< FileTemplateConfigInput > | null,
  landingBucketConfig?: LandingBucketInputConfig | null,
  lastModifiedBy?: string | null,
  numberOfFiles?: number | null,
  orgId: string,
  status?: OrgStatus | null,
  targetColumnMapping?: string | null,
  targetColumns?: Array< TargetColumnsInputConfig > | null,
};

export type FileTemplateConfigInput = {
  description: string,
  displayName: string,
  headers?: string | null,
  templateId?: string | null,
};

export type UpdateValidationResultsInput = {
  fileId: string,
  orgId: string,
  validationReportS3Key?: string | null,
  validationResults: string,
};

export type UpdateValidationResultsResponse = {
  __typename: "UpdateValidationResultsResponse",
  fileId: string,
  orgId: string,
  success: boolean,
};

export type Entitlements = {
  __typename: "Entitlements",
  entitlements?: Array< string > | null,
  role?: string | null,
};

export type HealthResponse = {
  __typename: "HealthResponse",
  environment: string,
  status: string,
  timestamp: string,
  version: string,
};

export type FileListRequest = {
  endDate?: string | null,
  limit?: number | null,
  nextToken?: string | null,
  orgId: string,
  search?: string | null,
  sortField?: string | null,
  sortOrder?: string | null,
  startDate?: string | null,
  statusValue?: string | null,
  tableFilter?: string | null,
};

export type FileList = {
  __typename: "FileList",
  items?:  Array<FileMetadata > | null,
  nextToken?: string | null,
};

export type ValidateFileInput = {
  orgId: string,
  s3Key: string,
};

export type ValidateFileResponse = {
  __typename: "ValidateFileResponse",
  extraColumns: Array< string >,
  isValid: boolean,
  matchedColumns: Array< string >,
  missingColumns: Array< string >,
  orgId: string,
  rowValidation: string,
  s3Key: string,
  summary: string,
};

export type ValidateHeadersInput = {
  orgId: string,
  s3Key: string,
};

export type ValidateHeadersResponse = {
  __typename: "ValidateHeadersResponse",
  extraColumns: Array< string >,
  isValid: boolean,
  matchedColumns: Array< string >,
  missingColumns: Array< string >,
  orgId: string,
  s3Key: string,
};

export type CreateFileMetadataMutationVariables = {
  metadataCreateRequest: CreateFileMetadataInput,
};

export type CreateFileMetadataMutation = {
  CreateFileMetadata:  {
    __typename: "FileMetadata",
    description?: string | null,
    errors?:  {
      __typename: "ErrorConfig",
      count?: number | null,
      errorDetails?: Array< string > | null,
    } | null,
    exportStatus?: ExportStatus | null,
    fileId: string,
    fileName: string,
    fileSize?: number | null,
    headers?: Array< string > | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    operatorsProcessed?: Array< string > | null,
    orgId: string,
    recordCount?: number | null,
    rowsProcessedList?: Array< string > | null,
    s3Key?: string | null,
    s3OutputKeys?: Array< string > | null,
    templateId: string,
    uploadBy?: string | null,
    uploadStatus?: UploadStatus | null,
    uploadedAt?: string | null,
    validationResults?: string | null,
  },
};

export type CreateOrganizationMutationVariables = {
  orgRequest: CreateOrganization,
};

export type CreateOrganizationMutation = {
  CreateOrganization:  {
    __typename: "Organization",
    createdAt: string,
    createdBy: string,
    fileTemplateConfig?:  Array< {
      __typename: "FileTemplateConfig",
      description: string,
      displayName: string,
      headers?: string | null,
      templateId?: string | null,
    } > | null,
    landingBucketConfig?:  {
      __typename: "LandingBucketConfig",
      bucketName: string,
      bucketPrefix: string,
      bucketRegion: string,
    } | null,
    lastModifiedAt: string,
    lastModifiedBy: string,
    numberOfFiles?: number | null,
    orgId: string,
    orgName: string,
    orgType: OrgType,
    status: OrgStatus,
    targetColumnMapping?: string | null,
    targetColumns?:  Array< {
      __typename: "TargetColumnsConfig",
      desc: string,
      key: string,
      tagName: string,
    } > | null,
  },
};

export type CreateUserMutationVariables = {
  userRequest: CreateUserInput,
};

export type CreateUserMutation = {
  CreateUser:  {
    __typename: "UserResponse",
    message?: string | null,
    success?: boolean | null,
  },
};

export type HashAndEncryptFileMutationVariables = {
  processRequest: HashAndEncryptRequest,
};

export type HashAndEncryptFileMutation = {
  HashAndEncryptFile:  {
    __typename: "ProcessResponse",
    message?: string | null,
    operatorsProcessed?: Array< string > | null,
    orgId?: string | null,
    rowsProcessed?: Array< number > | null,
    s3OutputKeys?: Array< string > | null,
    statusCode?: number | null,
    success?: boolean | null,
  },
};

export type PublishFileMutationVariables = {
  publishRequest: PublishRequest,
};

export type PublishFileMutation = {
  PublishFile:  {
    __typename: "PublishResponse",
    filesRemoved?: boolean | null,
    message?: string | null,
    orgId?: string | null,
    statusCode?: number | null,
    success: boolean,
  },
};

export type UpdateFileMetadataMutationVariables = {
  metadataUpdateRequest: UpdateFileMetadataInput,
};

export type UpdateFileMetadataMutation = {
  UpdateFileMetadata:  {
    __typename: "FileMetadata",
    description?: string | null,
    errors?:  {
      __typename: "ErrorConfig",
      count?: number | null,
      errorDetails?: Array< string > | null,
    } | null,
    exportStatus?: ExportStatus | null,
    fileId: string,
    fileName: string,
    fileSize?: number | null,
    headers?: Array< string > | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    operatorsProcessed?: Array< string > | null,
    orgId: string,
    recordCount?: number | null,
    rowsProcessedList?: Array< string > | null,
    s3Key?: string | null,
    s3OutputKeys?: Array< string > | null,
    templateId: string,
    uploadBy?: string | null,
    uploadStatus?: UploadStatus | null,
    uploadedAt?: string | null,
    validationResults?: string | null,
  },
};

export type UpdateOrganizationMutationVariables = {
  updateOrgInput: UpdateOrganizationInput,
};

export type UpdateOrganizationMutation = {
  UpdateOrganization:  {
    __typename: "Organization",
    createdAt: string,
    createdBy: string,
    fileTemplateConfig?:  Array< {
      __typename: "FileTemplateConfig",
      description: string,
      displayName: string,
      headers?: string | null,
      templateId?: string | null,
    } > | null,
    landingBucketConfig?:  {
      __typename: "LandingBucketConfig",
      bucketName: string,
      bucketPrefix: string,
      bucketRegion: string,
    } | null,
    lastModifiedAt: string,
    lastModifiedBy: string,
    numberOfFiles?: number | null,
    orgId: string,
    orgName: string,
    orgType: OrgType,
    status: OrgStatus,
    targetColumnMapping?: string | null,
    targetColumns?:  Array< {
      __typename: "TargetColumnsConfig",
      desc: string,
      key: string,
      tagName: string,
    } > | null,
  },
};

export type UpdateValidationResultsMutationVariables = {
  input: UpdateValidationResultsInput,
};

export type UpdateValidationResultsMutation = {
  UpdateValidationResults:  {
    __typename: "UpdateValidationResultsResponse",
    fileId: string,
    orgId: string,
    success: boolean,
  },
};

export type GetEntitlementsQueryVariables = {
  role: string,
};

export type GetEntitlementsQuery = {
  GetEntitlements?:  {
    __typename: "Entitlements",
    entitlements?: Array< string > | null,
    role?: string | null,
  } | null,
};

export type GetFileMetadataQueryVariables = {
  fileId?: string | null,
  orgId?: string | null,
};

export type GetFileMetadataQuery = {
  GetFileMetadata:  {
    __typename: "FileMetadata",
    description?: string | null,
    errors?:  {
      __typename: "ErrorConfig",
      count?: number | null,
      errorDetails?: Array< string > | null,
    } | null,
    exportStatus?: ExportStatus | null,
    fileId: string,
    fileName: string,
    fileSize?: number | null,
    headers?: Array< string > | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    operatorsProcessed?: Array< string > | null,
    orgId: string,
    recordCount?: number | null,
    rowsProcessedList?: Array< string > | null,
    s3Key?: string | null,
    s3OutputKeys?: Array< string > | null,
    templateId: string,
    uploadBy?: string | null,
    uploadStatus?: UploadStatus | null,
    uploadedAt?: string | null,
    validationResults?: string | null,
  },
};

export type GetHealthQueryVariables = {
};

export type GetHealthQuery = {
  GetHealth:  {
    __typename: "HealthResponse",
    environment: string,
    status: string,
    timestamp: string,
    version: string,
  },
};

export type GetOrganizationListQueryVariables = {
};

export type GetOrganizationListQuery = {
  GetOrganizationList:  Array< {
    __typename: "Organization",
    createdAt: string,
    createdBy: string,
    fileTemplateConfig?:  Array< {
      __typename: "FileTemplateConfig",
      description: string,
      displayName: string,
      headers?: string | null,
      templateId?: string | null,
    } > | null,
    landingBucketConfig?:  {
      __typename: "LandingBucketConfig",
      bucketName: string,
      bucketPrefix: string,
      bucketRegion: string,
    } | null,
    lastModifiedAt: string,
    lastModifiedBy: string,
    numberOfFiles?: number | null,
    orgId: string,
    orgName: string,
    orgType: OrgType,
    status: OrgStatus,
    targetColumnMapping?: string | null,
    targetColumns?:  Array< {
      __typename: "TargetColumnsConfig",
      desc: string,
      key: string,
      tagName: string,
    } > | null,
  } >,
};

export type ListFileMetadataQueryVariables = {
  input: FileListRequest,
};

export type ListFileMetadataQuery = {
  ListFileMetadata:  {
    __typename: "FileList",
    items?:  Array< {
      __typename: "FileMetadata",
      description?: string | null,
      errors?:  {
        __typename: "ErrorConfig",
        count?: number | null,
        errorDetails?: Array< string > | null,
      } | null,
      exportStatus?: ExportStatus | null,
      fileId: string,
      fileName: string,
      fileSize?: number | null,
      headers?: Array< string > | null,
      lastModifiedAt?: string | null,
      lastModifiedBy?: string | null,
      operatorsProcessed?: Array< string > | null,
      orgId: string,
      recordCount?: number | null,
      rowsProcessedList?: Array< string > | null,
      s3Key?: string | null,
      s3OutputKeys?: Array< string > | null,
      templateId: string,
      uploadBy?: string | null,
      uploadStatus?: UploadStatus | null,
      uploadedAt?: string | null,
      validationResults?: string | null,
    } > | null,
    nextToken?: string | null,
  },
};

export type ValidateFileQueryVariables = {
  input: ValidateFileInput,
};

export type ValidateFileQuery = {
  ValidateFile:  {
    __typename: "ValidateFileResponse",
    extraColumns: Array< string >,
    isValid: boolean,
    matchedColumns: Array< string >,
    missingColumns: Array< string >,
    orgId: string,
    rowValidation: string,
    s3Key: string,
    summary: string,
  },
};

export type ValidateHeadersQueryVariables = {
  input: ValidateHeadersInput,
};

export type ValidateHeadersQuery = {
  ValidateHeaders:  {
    __typename: "ValidateHeadersResponse",
    extraColumns: Array< string >,
    isValid: boolean,
    matchedColumns: Array< string >,
    missingColumns: Array< string >,
    orgId: string,
    s3Key: string,
  },
};

export type OnFileMetadataRecordUpdateSubscriptionVariables = {
};

export type OnFileMetadataRecordUpdateSubscription = {
  onFileMetadataRecordUpdate?:  {
    __typename: "FileMetadata",
    description?: string | null,
    errors?:  {
      __typename: "ErrorConfig",
      count?: number | null,
      errorDetails?: Array< string > | null,
    } | null,
    exportStatus?: ExportStatus | null,
    fileId: string,
    fileName: string,
    fileSize?: number | null,
    headers?: Array< string > | null,
    lastModifiedAt?: string | null,
    lastModifiedBy?: string | null,
    operatorsProcessed?: Array< string > | null,
    orgId: string,
    recordCount?: number | null,
    rowsProcessedList?: Array< string > | null,
    s3Key?: string | null,
    s3OutputKeys?: Array< string > | null,
    templateId: string,
    uploadBy?: string | null,
    uploadStatus?: UploadStatus | null,
    uploadedAt?: string | null,
    validationResults?: string | null,
  } | null,
};
